import u from "./ui.module.css";

export default function Card({
  children,
  title,
  subtitle,
  actions,
  padding = true,
  className = "",
  style,
}) {
  return (
    <div
      className={`${u.card} ${padding ? u.cardPadding : ""} ${className}`}
      style={style}
    >
      {(title || actions) && (
        <div className={u.cardHeader}>
          <div>
            {title && <h2 className={u.cardTitle}>{title}</h2>}
            {subtitle && <p className={u.cardSubtitle}>{subtitle}</p>}
          </div>
          {actions ? <div>{actions}</div> : null}
        </div>
      )}
      {children}
    </div>
  );
}
